import React, { useState, useRef, useEffect } from 'react';
import { Box } from '@mui/material';
import DragHandleIcon from '@mui/icons-material/DragHandle';
import { useTheme } from '../../contexts/ThemeContext';

// Modify your sidebar component to include resizing functionality
const ResizableSidebar = ({ children, width, setWidth, minWidth = 320, maxWidth = 600 }) => {
  const { theme } = useTheme();
  const [isDragging, setIsDragging] = useState(false);
  const sidebarRef = useRef(null);
  const startXRef = useRef(0);
  const startWidthRef = useRef(0);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    startXRef.current = e.clientX;
    startWidthRef.current = width;
    document.body.style.cursor = 'col-resize';
    document.body.style.userSelect = 'none';
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    const delta = startXRef.current - e.clientX;
    const newWidth = Math.max(minWidth, Math.min(maxWidth, startWidthRef.current + delta));
    setWidth(newWidth);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    document.body.style.cursor = '';
    document.body.style.userSelect = '';
  };

  useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    } else {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    }

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging]);

  const resizeHandleStyles = {
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    width: '5px',
    cursor: 'col-resize',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    zIndex: 100,
    '&:hover': {
      backgroundColor: theme.border.medium,
    },
    '&:active': {
      backgroundColor: theme.color.primary,
    }
  };

  const sidebarStyles = {
    width: `${width}px`,
    borderLeft: `1px solid ${theme.border.medium}`,
    display: 'flex',
    flexDirection: 'column',
    bgcolor: theme.background.secondary,
    minHeight: '100%',
    position: 'relative',
    transition: isDragging ? 'none' : 'width 0.1s ease',
  };

  return (
    <Box ref={sidebarRef} sx={sidebarStyles}>
      <Box
        sx={resizeHandleStyles}
        onMouseDown={handleMouseDown}
      >
        <DragHandleIcon
          sx={{
            transform: 'rotate(90deg)',
            color: theme.text.secondary,
            opacity: 0.7,
            fontSize: '16px',
            visibility: 'hidden',
            '.MuiBox-root:hover &': {
              visibility: 'visible',
            }
          }}
        />
      </Box>
      {children}
    </Box>
  );
};

export default ResizableSidebar;